<template>
  <div :class="classes">
    <div class="d-flex justify-space-between flex-column flex-md-row">
      <h2 class="mb-8 standard-layout__heading">{{ $ucfirst($t('people.patient')) }}</h2>
      <div class="d-flex flex-wrap flex-column flex-md-row mb-4 mb-md-0">
        <open-d-s-s-button></open-d-s-s-button>
<!--        <div class="patient-overview__patient-record-btn ml-md-3 mb-md-8 mb-4">-->
<!--                    <open-patient-record-button-->
<!--                      v-if="!type"-->
<!--                    />-->
<!--        </div>-->
        <div class="patient-overview__patient-record-btn ml-md-3 mb-md-8 mb-4">
          <v-btn
              v-if="!type"
              x-large
              text
              @click="checkViewPatientRecord"
          >
            {{ $t("patient.viewpatientrecord") }}
          </v-btn>
        </div>
        <div class="patient-overview__patient-record-btn ml-md-3 mb-md-8 mb-4">
          <v-btn
              v-if="isSDMButtonAvailable"
              x-large
              text
              @click="checkStartEncounter"
          >
            {{ $ucfirst(
              $t("patient.startvisit", {
                params: { visitNumber: currentVersion },
              }))
            }}
          </v-btn>
        </div>
      </div>
    </div>
    <div class="mb-6">
      <general-patient-search class="patient-overview__search-patients" />
    </div>
    <div class="patient-overview__layout-top">
      <patient-overview-general
        class="patient-overview__general-section"
      ></patient-overview-general>
      <div class="patient-overview__layout-top-right">
        <patient-overview-timeline
          class="patient-overview__timeline-section"
        ></patient-overview-timeline>
        <patient-overview-parameters
          class="patient-overview__parameters-section"
        ></patient-overview-parameters>
        <patient-overview-behaviour-change
          class="patient-overview__behaviour-section"
        ></patient-overview-behaviour-change>
      </div>
    </div>
    <patient-overview-recent-alerts
      class="patient-overview__recent-alerts-section"
    ></patient-overview-recent-alerts>

    <v-dialog v-model="showNextActionDialog" max-width="700px">
      <div class="dashboard-dialog-window">
        <div v-if="remainingQuestionnaireKeys.length > 0" class="dashboard-dialog-window__message">
          <div class="d-flex pb-5">
            <v-icon class="mr-2"> mdi-help </v-icon>
            {{ $ucfirst($t("patient.startvisitconfirmation", {
            params: { visitNumber: currentVersion },
          })) }}
          </div>

          <div class="d-flex pb-5 color-coro-warning-500">
            <v-icon :color="$color.coro['warning-500']" class="mr-2">
              mdi-alert
            </v-icon>
            {{ $ucfirst($t("patient.noinfoquestionnaire")) }}
          </div>
        </div>

        <div
            v-if="nextAction === 'startEncounter'"
            class="dashboard-dialog-window__message">
          {{
            $ucfirst(
                $t("patient.enterSubjectIdToStartVisit", {
                  params: { visitNumber: currentVersion },
                })
            )
          }}
        </div>

        <v-text-field
            v-if="nextAction === 'startEncounter'"
            autofocus
            class="mt-6"
            v-model="patientSubjectId"
            dense
            :error="!!errorMessage"
            :error-messages="errorMessage"
            :placeholder="
            $ucfirst(
              $t('pdf.medicationPrescription.subjectId', {
                catalog: 'messages',
              })
            )
          "
            ref="dialogInput"
        >
        </v-text-field>

        <div class="dashboard-dialog-window__actions mt-6">
          <v-btn x-large text class="ml-4" @click="closeStartSessionWarningDialog" color="primary">
            {{ $ucfirst($t("buttons.cancel", { catalog: "app_mobile" })) }}
          </v-btn>
          <v-btn x-large text class="ml-4" @click="handleNextAction">
            <span v-if="nextAction === 'viewPatientRecord'">
              {{ $t("buttons.proceed", "app_mobile") }}
            </span>
            <span v-else-if="nextAction === 'startEncounter'">
                  {{ $ucfirst(
                    $t("patient.startvisit", {
                      params: { visitNumber: currentVersion },
                    }))
                   }}
            </span>

          </v-btn>
        </div>
      </div>
    </v-dialog>


  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GeneralPatientSearch from "dashboard/templates/components/Patient/GeneralPatientSearch";
// import OpenPatientRecordButton from "dashboard/templates/components/Patient/OpenPatientRecordButton";
import PatientOverviewGeneral from "./PatientOverviewGeneral";
import PatientOverviewTimeline from "./PatientOverviewTimeline";
import PatientOverviewParameters from "./PatientOverviewParameters";
import PatientOverviewBehaviourChange from "./PatientOverviewBehaviourChange";
import PatientOverviewRecentAlerts from "./PatientOverviewRecentAlerts";
import OpenDSSButton from '../../../components/Parts/OpenDSSButton.vue';

/**
 * Component PatientOverview.vue
 *
 * @module PatientOverview
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.3] app/src/APP_DASHBOARD/templates/views/Patient/Overview/PatientOverview.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: 'PatientOverviewMain',
  props: {
    patientId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      nextAction: null,
      showNextActionDialog: false,
      remainingQuestionnaireKeys : [],
      errorMessage: "",
      patientSubjectId: "",
    }
  },
  components: {
    // OpenPatientRecordButton,
    GeneralPatientSearch,
    PatientOverviewGeneral,
    PatientOverviewTimeline,
    PatientOverviewParameters,
    PatientOverviewBehaviourChange,
    PatientOverviewRecentAlerts,
    OpenDSSButton
  },
  watch : {
    nextAction: function(newValue){
      this.showNextActionDialog = !!newValue
    }
  },
  methods : {
    async checkViewPatientRecord() {
      await this.viewPatientRecord();


      // No need for a questionnaires check when just viewing the patient record.

      // await this.checkQuestionnaires();
      //
      // // If some questionnaires still need to be filled in, show popup warning.
      // this.nextAction = this.remainingQuestionnaireKeys.length > 0 ? 'viewPatientRecord' : null;
      //
      // // If the questionnaires are all ok, open the patient record directly instead of opening popup warning.
      // if (!this.nextAction) {
      //   await this.viewPatientRecord();
      // }

    },
    // viewPatientRecord (start session for followup)
    async viewPatientRecord() {
      try {
        this.closeStartSessionWarningDialog();

        await this.$store.dispatch("followupSession/startRegular");

        this.$router.push({ name: "PatientRecordProgressStatusJourney" });
        this.$toasted.show(
            this.$t("dummy.SDM.new_followup_started", {
              params: {
                patientName: this.$store.getters["patientSummary/studyId"],
              },
            })
        );
      } catch (error) {
        return;
      }
    },
    async checkStartEncounter() {
      await this.checkQuestionnaires();
      this.nextAction = 'startEncounter';
    },
    startEncounter() {
        if (!this.patientSubjectId) {
          this.errorMessage = this.$ucfirst(this.$t("validation.IS_REQUIRED"));
        } else if (
            this.patientSubjectId.toLowerCase() !== this.subjectId.toLowerCase()
        ) {
          this.errorMessage = this.$ucfirst(this.$t("validation.subjectIdDoesntCorrespond"));
          this.$toasted.show(
              this.$ucfirst(this.$t("validation.subjectIdDoesntCorrespond")) +
              " " +
              this.$ucfirst(this.$t("validation.enterCorrectIdToStartVisit")),
              {
                type: "error",
                position: "bottom-center",
                duration: 6000,
              }
          );
        } else {
          this.closeStartSessionWarningDialog();

          this.$router.push({
            name: "PatientEncounterVitalSigns",
            params: { version: this.currentVersion },
          });
        }
    },
    async handleNextAction() {
      if (this.nextAction === 'viewPatientRecord') {
        await this.viewPatientRecord();
      }else if (this.nextAction === 'startEncounter') {
        this.startEncounter();
      }
    },
    closeStartSessionWarningDialog() {
      this.nextAction = null
      this.remainingQuestionnaireKeys = []
      this.errorMessage = ''
      this.patientSubjectId = ''
    },
    async checkQuestionnaires () {
      const collectionKey = "BEFORE_" + this.currentVersion,
          qManager = this.$app.questionnaireManager;

      const collection = await qManager.getEProConfigurationCollection(
          this.subjectId,
          collectionKey
      );

      this.remainingQuestionnaireKeys = collection.remainingQuestionnaireKeys
    }
  },
  computed: {
    ...mapGetters({
      type: 'followupSession/type',
      currentVersion: "patientSummary/currentVersion",
      subjectId: "patientSummary/studyId",
      isSDMStarted: "followupSession/isSDMStarted",
      isFollowUpStarted: "followupSession/isFollowUpStarted",
      lastVersion: "patientSummary/lastVersion",
      getEncounter: "patientSummary/getEncounter",
    }),
    classes() {
      return {
        'patient-overview': true,
        'standard-layout': !this.type,
      };
    },
    isSDMButtonAvailable() {
      return (
          this.currentVersion &&
          !this.isSDMStarted &&
          !this.isFollowUpStarted &&
          this.lastVersion &&
          !(this.getEncounter(7) && this.currentVersion === 7)
      );
    },
  },
  beforeUpdate() {
    // only after patientSummary has been loaded and the compopnent is about to update
    // redirect to record screen instead of overview if follow up/SDM still in session
    if (this.type && this.$route.name === 'PatientOverview') {
      this.$router.push({ name: 'PatientRecordOverview', params: { patientId: this.patientId } })
    }
  },
};
</script>

<style lang="scss">
// tablet screens
.v-application.md-up {
  .patient-overview__search-patients {
    max-width: 50%;
  }
}

.v-application.lg-up {
  .patient-overview__general-section {
    margin-right: 24px;
    width: calc(40% - 24px);
  }

  .patient-overview__layout-top-right {
    width: 60%;
    display: flex;
    flex-direction: column;
  }
}

.patient-overview__layout-top {
  margin-top: 24px;
  display: flex;
  flex-wrap: wrap;
}

.patient-overview__layout-top-right {
  width: 100%;
}

.patient-overview__general-section {
  padding-bottom: 12px !important;
}

.patient-overview__general-section,
.patient-overview__parameters-section,
.patient-overview__behaviour-section {
  margin-bottom: 24px;
  width: 100%;
}

.patient-overview__timeline-section {
  margin-bottom: 24px;
}

.patient-overview__icon {
  margin-right: 12px;
}

.patient-overview__card-content {
  display: flex;
  line-height: 2;
}

.patient-overview__parameter-row {
  white-space: nowrap;
}

.patient-overview-parameter--green {
  color: #4caf50;
}

.patient-overview-parameter--red {
  color: #f44336;
}

.patient-overview-parameter--orange {
  color: #ff9800;
}

.patient-overview__patient-record-btn {
  .v-btn {
    width: 100%;
  }
}

.patient-overview {
  .v-card {
    padding: 24px;
  }
}

.patient-overview__table {
  font-family: Roboto, sans-serif;
  font-weight: 400;
  margin-bottom: 24px;

  table > tbody > tr:hover {
    background-color: transparent !important;
  }

  table > tbody > tr > td {
    font-size: 1rem !important;
    line-height: 1.6 !important;
  }

  table > tbody > tr > td:first-child {
    padding-left: 0 !important;
  }
}

.patient-overview__table:last-child {
  margin-bottom: 0;
}
</style>
